import { groq } from 'next-sanity'
import { getClient } from './getClient'

export const getLlmsTxt = async (preview = false): Promise<string | null> => {
  const query = groq`*[_type == "llmsTxt"][0].content`

  const content = await getClient(preview).fetch<string | null>(query)

  return content
}
